/**
 * Tour target ids, resolved by the demo bridge to a DOM element.
 *
 * These strings are a cross-repo contract: the shell looks each one up by
 * exact match and reports a miss silently, so a rename here is a two-repo
 * change. Source of truth is `TOUR_STEPS` in
 * `pp_fe_demo_account_v2:src/constants/journey.ts`.
 *
 * `checkout.edd` is deliberately absent — it is written onto the generated
 * checkout wrapper in `pp_genai_demo_account`, and nothing in this repo
 * resolves it.
 */
export const DEMO_TARGET_ATTRIBUTE = 'data-pp-demo-target';

export const DEMO_TARGET = {
  shipmentToggle: 'ptp.shipment-toggle',
  confirmSummary: 'ptp.confirm-summary',
  rating: 'ptp.rating',
  returnCta: 'ptp.return-cta',
} as const;
